module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.3cf51677.mp3";